import { ETooltipIntents, ETypographyIntents } from '@src/typings';
import { inputVariants } from '@src/utilities/inputVariants';
import { Input as InputAntD, type InputRef } from 'antd';
import { ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { withTheme } from '../ThemeProvider';
import { Tooltip } from '../Tooltip';
import {
    StyledError,
    StyledInputWrapper,
    StyledLabel,
    StyledRequiredMark,
} from './styles';
import { InputProps } from './types';

const InputComponent = forwardRef(
    (
        {
            intent,
            size,
            className,
            children,
            label,
            name,
            error,
            isRequired,
            help,
            ...props
        }: InputProps,
        ref: ForwardedRef<InputRef>
    ) => {
        return (
            <StyledInputWrapper>
                {(label || help) && (
                    <div className="flex w-full items-center justify-between mb-2.5">
                        <StyledLabel
                            intent={ETypographyIntents.Regular}
                            className="flex items-center justify-start gap-x-1"
                        >
                            <span>{label}</span>
                            {isRequired && (
                                <StyledRequiredMark>*</StyledRequiredMark>
                            )}
                        </StyledLabel>
                        {help && (
                            <Tooltip
                                title={help}
                                color="secondary"
                                intent={ETooltipIntents.Question}
                            />
                        )}
                    </div>
                )}
                <InputAntD
                    ref={ref}
                    status={error ? 'error' : props.status}
                    variant={intent}
                    className={twMerge(
                        inputVariants({
                            className,
                            intent,
                            size,
                            error: Boolean(error),
                        })
                    )}
                    {...props}
                />
                {error && (
                    <StyledError intent={ETypographyIntents.Badge}>
                        {error}
                    </StyledError>
                )}
            </StyledInputWrapper>
        );
    }
);

InputComponent.displayName = 'InputComponent';

export const Input = withTheme(InputComponent);
